export const authenticated = false;

let userDetail = {
  email: '',
  name: '',
  surname: '',
  token: '',
  user_id: 0,
  left_input: 0,
};

export const setUserDetail = (detail) => {
  localStorage.setItem('user', JSON.stringify(detail));
  userDetail = detail;
};

export const initUserDetail = () => {
  const hasUser = localStorage.getItem('user');
  if (hasUser) {
    userDetail = JSON.parse(hasUser);
  }
};

export const authToken = () => {
  initUserDetail();
  if (userDetail.token) {
    return userDetail.token;
  }
  return '';
};

export const defaultHeader = () => ({ Authorization: `Token ${authToken()}` });

export const logout = () => {
  localStorage.clear();
  userDetail = {};
};

export const user = () => userDetail;
